import { Link } from "react-router-dom";
import { ArrowRight, PhoneCall } from "lucide-react";

export const Hero = ({ content }) => (
  <section className="relative overflow-hidden grain" data-testid="home-hero">
    <div className="container-site pt-12 pb-16 md:pt-20 md:pb-24 grid gap-12 lg:grid-cols-[1.2fr_1fr] items-center">
      <div className="animate-fade-up">
        <p className="eyebrow mb-5" data-testid="home-tagline">{content.tagline}</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl leading-[1.04] max-w-[16ch]" data-testid="home-hero-headline">{content.hero_headline}</h1>
        <p className="mt-6 text-base md:text-lg text-ink-soft max-w-[58ch]">{content.hero_text}</p>
        <div className="mt-9 flex flex-col sm:flex-row gap-3">
          <Link to="/find-your-way" className="btn-primary" data-testid="hero-find-next-step-btn">Find Your Next Step <ArrowRight className="h-5 w-5" aria-hidden="true" /></Link>
          <Link to="/support" className="btn-secondary" data-testid="hero-explore-support-btn">Explore Support</Link>
        </div>
        <Link to="/urgent-help" className="mt-7 inline-flex items-center gap-2 text-[0.95rem] font-semibold text-clay-dark underline underline-offset-4" data-testid="hero-urgent-help-link">
          <PhoneCall className="h-4 w-4" aria-hidden="true" /> Need urgent help? See who to contact now
        </Link>
      </div>
      <div className="relative animate-fade-up [animation-delay:150ms]">
        <div className="hidden sm:block absolute -top-6 -right-6 h-40 w-40 rounded-full bg-sage/50" aria-hidden="true" />
        <img src="/images/hero.jpg" alt="Two people sitting side by side, each holding a glass mug of tea" className="relative w-full h-[320px] sm:h-[420px] lg:h-[520px] object-cover rounded-[2.5rem]" />
        <div className="absolute -bottom-6 left-6 right-6 sm:left-auto sm:right-8 sm:max-w-xs card-soft !bg-cream-warm/95 backdrop-blur p-5">
          <p className="font-serif text-lg leading-snug">You are not alone. You deserve support too. There is a way forward.</p>
        </div>
      </div>
    </div>
  </section>
);
